export function groupBy<ItemType, KeyType extends keyof ItemType>(src: readonly ItemType[], key: KeyType) {
	return src.reduce((acc, val) => {
		let thisItem = acc.find((item) => item.key === val[key]);
		if (!thisItem) {
			acc.push(thisItem = { key: val[key], value: [], });
		}

		thisItem.value.push(val);

		return acc;
	}, [] as Array<{ key: ItemType[KeyType], value: ItemType[], }>);
}
